import { Subject, filter } from "rxjs";
export class EventBus {
    constructor() {
        /**
         * Over-arching event bus uses a Subject
         */
        this.bus = new Subject();
    }
    /**
     * Add an event to the event bus so consumers can subscribe to it.
     * @param data
     */
    produce({ event }) {
        this.bus.next(event);
    }
    /**
     * Retrieve events in a stream with a certain event type.
     * @param data
     * @returns
     */
    getByType$({ type, }) {
        return this.bus.pipe(filter((event) => event.type === type));
    }
}
export default EventBus;
//# sourceMappingURL=EventBus.js.map